__turbopack_context__.v({
  "loginButtonText": "page-module__aydn6q__loginButtonText",
  "loginContainer": "page-module__aydn6q__loginContainer",
  "loginDividerText": "page-module__aydn6q__loginDividerText",
  "loginInputText": "page-module__aydn6q__loginInputText",
  "loginLabelText": "page-module__aydn6q__loginLabelText",
  "loginLinkText": "page-module__aydn6q__loginLinkText",
  "loginPromoText": "page-module__aydn6q__loginPromoText",
  "loginSubtitle": "page-module__aydn6q__loginSubtitle",
  "loginTermsText": "page-module__aydn6q__loginTermsText",
  "loginTitle": "page-module__aydn6q__loginTitle",
});
